import React from "react"
import ReactDOM from 'react-dom';

export class ErrorMessage extends React.Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <div className="alert alert-danger">
        {this.props.message.split('\n').map((item, key) => {
          return <span key={key}>{item}<br/></span>
        })}
      </div>
    );
  }
}
